<template>
  <widget :title="title">
    <template v-slot:content>
      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left">Item</th>
              <th class="text-left">Status</th>
              <th class="text-left">Due</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="item in actionItems.items"
              :key="item.actionItemId"
            >
              <td>{{ item.name }}</td>
              <td>{{ item.status }}</td>
              <td>{{ item.due_on }}</td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </template>
  </widget>
</template>

<script>

import store from '@/store'
import Widget from './Widget'

export default {
  name: 'ActionItemsWidget',
  components: {
    Widget
  },
  data () {
    return {
      title: 'Action Items'
    }
  },
  computed: {
    actionItems () {
      return store.state.dashboard.actionItems
    }
  },
  beforeMount () {
    store.dispatch('dashboard/fetchActionItems')
  }
}
</script>

<style scoped>

</style>
